$(document).ready(function(){

// Collection Page Grid and List
  $('.grid-facets-flex-main .grid-facets-flex-three').addClass('active');
  $('.grid-facets-flex-main .grid-facets-flex-three, .grid-facets-flex-main .grid-facets-flex-two').click(function() {
      $('.grid-facets-flex-main .grid-facets-flex-three, .grid-facets-flex-main .grid-facets-flex-two').removeClass('active');
      $(this).addClass('active');
  
      var $productGrid = $(this).parents('.main-collection-product-facets').find('#ProductGridContainer #product-grid');  
      if ($(this).hasClass('grid-facets-flex-three')) {
          $productGrid.addClass('product-grid-list-3');
          $productGrid.removeClass('product-grid-list-2');
      } else if ($(this).hasClass('grid-facets-flex-two')) {
          $productGrid.addClass('product-grid-list-2');
          $productGrid.removeClass('product-grid-list-3');
      }
  });

// Collection Page In-Stock and Out-Stock  
  $(".filter_stock_wrap #collection-filter__item-stock-toggle-label").change(function () {
      $('.filter_stock_wrap label').attr('for', 'Filter-Availability-1');
  });
  $(".filter_stock_wrap #Filter-Availability-1").change(function () {
      $('.filter_stock_wrap label').attr('for', 'collection-filter__item-stock-toggle-label');
  });

  // $(document).on("change","#collection-filter__item-stock-toggle-label",function(){
  //   if($(this).is(':checked') == true){
  //     $('input[name="filter.v.availability"][value="1"]').trigger("click");
  //   }else{
  //     $('input[name="filter.v.availability"][value="1"]').trigger("click");
  //   }
  // });

  
// Product Page AddAccessories Checkbox
  $('.product-access-button button').click(function(){
    var AddAccessoriesblock = $(this).closest('.product-add-accessories-block');
    AddAccessoriesblock.toggleClass('add-accessories-checked');  
    var AddAccesscheckbox = AddAccessoriesblock.find('.block__complete-set-productcheckbox input[type="checkbox"]');
    AddAccesscheckbox.prop('checked', !AddAccesscheckbox.prop('checked'));    
    var buttonText = AddAccesscheckbox.prop('checked') ? 'Added' : 'Add';
    $(this).text(buttonText);
  });

// Master Class
 $('.product-master__Content .button').click(function(){
    var content = $(this).closest('.product-master__Content');
    var productMasterPrice = $(".product-total-price").data("productmaster"); 
    var productPrice = $(".product-total-price").data("productprice"); 

    var price_input_raw = $(".product-total-price").data("productprice");
    var price_input = parseFloat(price_input_raw);

    var PriceMaster = parseFloat($(".product-total-price").data("productmaster"));
    var quntityPriceMaster = (parseFloat(price_input) + PriceMaster).toFixed(2);   
   
    content.toggleClass('add-masterclass-checked');     
    var checkbox = content.find('input[type="checkbox"]');
    var isChecked = !checkbox.prop('checked');
    checkbox.prop('checked', isChecked);
    if (isChecked) {
        $(this).text('Added'); 
        $(".product-total-price").text(productMasterPrice);  
        var quntityPriceMaster = (parseFloat(price_input) + PriceMaster);  
        $(".product-total-price").text(Shopify.formatMoney(quntityPriceMaster, Shopify.money_format));
    } else {
      $(this).text('Add'); 
      $(".product-total-price").text(productPrice);
      var quntityPriceMaster = parseFloat(price_input);  
      $(".product-total-price").text(Shopify.formatMoney(quntityPriceMaster, Shopify.money_format));
    }
});
  
$('.quantity__input').on('change', function() {  
  var price_input_raw = $(".product-total-price").data("productprice");
  var price_input = parseFloat(price_input_raw);

  var quantity_input_raw = $(this).val();
  var quantity_input = parseInt(quantity_input_raw);

  var quntity_input_price = parseFloat(price_input * quantity_input);
  // var PriceMaster = parseFloat($(".product-total-price").data("productmaster"));
  
  // var quntityPriceMaster = (parseFloat(quntity_input_price) + PriceMaster);    
  $(".product-total-price").text(Shopify.formatMoney(quntity_input_price, Shopify.money_format));

});

// Product Page Tabify Stitch
$(document).on('change', 'input[type="checkbox"][class*="stitch-input-text-"]', function(){
  var className = $(this).attr('class');
  if ($(this).prop('checked')) {
    $('.stitch-tutrial-hand-check-main').addClass('tutorial-hand-checked');
  } else {
    $('.stitch-tutrial-hand-check-main').removeClass('tutorial-hand-checked');
  }
});

// Trigger change event manually if needed on page load or dynamically added elements
$('input[type="checkbox"][class*="stitch-input-text-"]').trigger('change');
  
// Collection Page Mobile View Fiter Drawer JS
  $(document).on("click" ,".mobile-facets__summary" , function(){
    $(this).parents(".mobile-facets__details").find(".mobile-facets__list").slideToggle();
    $(this).parents(".mobile-facets__details").find(".mobile-facets__arrow").toggleClass("active");  
  });

// Header on Hover Menu navigation
  $(".header__categories_menu_liststyle li").mouseenter(function() {
      var subTab = $(this).data("sub-tab");
      $(".header__categories_menumain").each(function() {
          if ($(this).data("sub-tab-menus") === subTab) {
              $(this).addClass("categories-current-menusub");
          } else {
              $(this).removeClass("categories-current-menusub");
          }
      });
      $(".header__categories_menu_liststyle li").removeClass("categories-current-sub");
      $(this).addClass("categories-current-sub");
  });

// Mobile Menu Submenu Open  
  $(".drawer_leval_one").click(function(){
     $(this).toggleClass("active").parents("li").siblings().find(".drawer_leval_one").removeClass("active")
     $(this).parents(".top_mob_menu").find(".menu-drawer-submenusnavigation").slideToggle().parents("li").siblings().find(".menu-drawer-submenusnavigation").slideUp();
  });

// Account Page Order History Accordion Js 
  $('.order-history-main-block-inner-right').click(function(){
    var $OrderHistory = $(this).closest('.order-history-main-block-inner-main').find('.order-history-block-inner-top-accordion');
    $('.order-history-block-inner-top-accordion').not($OrderHistory).slideUp();
    $OrderHistory.slideToggle();
    $('.order-history-main-block-inner-main').not($(this).closest('.order-history-main-block-inner-main')).removeClass('order-history-active');
    $(this).closest('.order-history-main-block-inner-main').toggleClass('order-history-active');
  });

// Product Page Tabs
  $('.product__accordion-inner').first().addClass('pdp-tabs-active').find('.accordion__content').show();
    $('.product__accordion .summary-tab').click(function() {
        var parentInnerDiv = $(this).closest('.product__accordion-inner');
        var tabTitle = $(this).data('product-tab-title');
        var tabContent = parentInnerDiv.find('.accordion__content').data('product-tab-content');

        if (tabTitle === tabContent) {
            if (parentInnerDiv.hasClass('pdp-tabs-active')) {
                parentInnerDiv.removeClass('pdp-tabs-active');
                parentInnerDiv.find('.accordion__content').slideUp();
            } else {
                $('.product__accordion-inner').removeClass('pdp-tabs-active');
                $('.accordion__content').slideUp();
                parentInnerDiv.addClass('pdp-tabs-active');
                parentInnerDiv.find('.accordion__content').slideDown();
            }
        }
    });

// Wool Template For Mobile Toggle Js

// $('.product-titlewool-wrap').first().addClass('woolproduct-active').find('.woolproducts-wrap').show();
// $('.product-title-wool-flex').click(function() {
//     var parent = $(this).closest('.product-titlewool-wrap');
//     if (!parent.hasClass('woolproduct-active')) {
//         $('.product-titlewool-wrap.woolproduct-active .woolproducts-wrap').slideUp();
//         $('.product-titlewool-wrap.woolproduct-active').removeClass('woolproduct-active');
//         parent.find('.woolproducts-wrap').slideDown();
//         parent.addClass('woolproduct-active');
//     }
// });

$('.block__header--megamenu-list').hover(
   function(){
     $(this).find('.header__menu-item').addClass('hover-menu-main');
     $(this).find('.header__categories').fadeIn(100);
   },
   function(){
     $(this).find('.header__menu-item').removeClass('hover-menu-main');
     $(this).find('.header__categories').fadeOut(100);
   }  
) 

$('.facets__disclosure-vertical .facets__display-vertical ul, #FacetsWrapperMobile .mobile-facets__details ul').each(function(){
  var LiN = $(this).find('.list-menu__item').length;
  if( LiN > 12){    
    $('.list-menu__item', this).eq(12).nextAll().hide().addClass('toggleable');
    $(this).append('<li class="more">+ 12 more</li>');    
  }  
});
$('.facets__disclosure-vertical .facets__display-vertical ul,#FacetsWrapperMobile .mobile-facets__details ul').on('click','.more', function(){
  if( $(this).hasClass('less') ){    
    $(this).text('+ 12 more').removeClass('less');    
  }else{
    $(this).text('- 12 more').addClass('less'); 
  }
  $(this).siblings('.list-menu__item.toggleable').slideToggle(); 
}); 
  
$('.account-sidebar-nav li').click(function(){
  $(".account-sidebar-nav li").removeClass("customer-main-active");
  $(this).addClass('customer-main-active');
});
// =============rebuy-cart==========
$(document).on("click", ".block_also-like-section .rebuy-button, .block_also-like-section .rebuy-button span , .rebuy-product-actions", function() {  
  setTimeout(function() {
     fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
          .then((response) => response.text())
          .then((responseText) => {
              const cartid = 'CartDrawer';
              const html = new DOMParser().parseFromString(responseText, 'text/html')
              const destination = document.querySelector('#CartDrawer');
              const source = html.getElementById(cartid);
              if (source && destination) destination.innerHTML = source.innerHTML;                      
              $.ajax({
                  url: '/?section_id=cart-icon-bubble',
                  type: 'GET',
                  dataType: 'html',
                  success: function(itemcount) {
                      $("#cart-icon-bubble").html($(itemcount).html());
                      $(".cart-count-bubble").trigger("click");  
                      Rebuy.init();
                  }
              });
          });
        }, 2000);
    });
  
});

document.addEventListener('rebuy.init', function(event) {
  setTimeout(function() {
  let upsell_rebuy_products = event.detail.widget.data.products;
  upsell_rebuy_products.forEach(function(product) {
    if (product.metafields.custom.letter_validation == true || product.metafields.custom.letter_validation == "true") {
        let card = $(`.cart-recommendation-wrapper .rebuy-product-block.product-id-${product.id}`); 
        console.log(card, "PRD-card")
        $(`.cart-recommendation-wrapper .rebuy-product-block.product-id-${product.id}`).find('button').css('display', 'none'); 
        $(`.cart-recommendation-wrapper .rebuy-product-block.product-id-${product.id}`).find('.rebuy-product-actions').html(`<a class="rebuy-button-redirect" href="${product.link}">View product</a>`);
      }
    });
  }, 1000);
});
$(document).ready(function(){
  if( $('.product-form__submit').length > 0){
    $('.block_in-stock-text').css('width', $('.product-form__submit').innerWidth());
  }
})

function initCartImageZoom() {
  const drawer = document.querySelector('#CartDrawer');
  if (!drawer) return;

  drawer.removeEventListener('click', drawer._zoomListener);

  drawer._zoomListener = function(e) {
    const img = e.target.closest('.cart-item__media .cart-item__image');
    if (!img) return;

    const imgSrc = img.src.replace('width=300', 'width=1024');

    const modal = document.createElement('div');
    modal.classList.add('zoom-modal');
    modal.innerHTML = `
      <div class="zoom-overlay">
        <img src="${imgSrc}" class="zoomed-image" />
        <span class="close-btn">&times;</span>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelector('.close-btn').addEventListener('click', () => modal.remove());

    modal.querySelector('.zoom-overlay').addEventListener('click', (ev) => {
      if (ev.target === modal.querySelector('.zoom-overlay')) modal.remove();
    });
  };

  drawer.addEventListener('click', drawer._zoomListener);
}

initCartImageZoom();





